import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { Typography } from '@mui/material';

const ClientProfileCard = ({ client,clientData }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Toggle the chatbot visibility
  const handleChatClick = () => {
    setIsChatOpen(!isChatOpen);
  };

  const handleCloseChat = () => {
    setIsChatOpen(false);
  };

  return (
    <div style={styles.card}>
      <div style={styles.imageContainer}>
        <img src={client.image} alt={client.name} style={styles.image} />
        <Typography sx={{fontWeight:"bold"}}>CEO</Typography>
        <p style={styles.ceo}>{clientData.name}</p>
        <div style={styles.iconContainer}>
          <Icon icon={client.icon2} style={styles.icon} />
          <Icon icon={client.icon} style={styles.icon} />
        </div>
      </div>
      <div style={styles.divider}></div>
      <div style={styles.details}>
        <h3 style={styles.name}>{client.name}</h3>
        <p style={styles.position}>{clientData.name}</p>
        <div style={styles.divider1}></div>



        <p style={styles.brief}>{client.details}</p>
        <div style={styles.infoContainer}>
  <div style={styles.leftColumn}>
    <p style={styles.info}>
      <Icon icon="mdi:email-outline" style={styles.infoIcon} /> {client.email}
    </p>
    <p style={styles.info}>
      <Icon icon="mdi:phone-outline" style={styles.infoIcon} /> {client.phone}
    </p>
  </div>
  <div style={styles.rightColumn}>
    <p style={styles.info}>
      <Icon icon="mdi:cake-variant-outline" style={styles.infoIcon} /> {client.dob}
    </p>
    <p style={styles.info}>
      <Icon icon="mdi:map-marker-outline" style={styles.infoIcon} /> {client.address}
    </p>
  </div>
</div>

      </div>
    </div>
  );
};

const styles = {
  card: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '15px',
    padding: '20px',
    margin: '10px',
    backgroundColor: '#ffffff',
    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
    width: '100%',
    overflow: 'hidden',
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: '20px',
  },
  image: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '10px',
    backgroundColor: '#f0f0f0',
    padding: '5px',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    width: 'auto',
    marginTop: '10px',
  },
  icon: {
    fontSize: '24px',
    color: '#2F3B57',
    cursor: 'pointer',
  },
  divider: {
    height: '130px',
    width: '1px',
    backgroundColor: '#ddd',
    marginRight: '20px',
  },
  divider1: {
    width: '150%',
    height: '1px',
    backgroundColor: '#ddd',
    margin: '10px 0',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  name: {
    fontSize: "1.2rem",
    fontWeight: "600",
    textAlign: "left", // Ensures alignment to the left
    color: "#2c3e50",
    marginBottom: "10px",
  },
  position: {
    fontSize: '0.7rem',
    color: 'gray',
    // backgroundColor: "#B9D9EB",
  marginTop:"-10px",
  marginRight:"2px",
    textAlign:"left",
    // padding: "5px",
    // borderRadius: "5px",
  },
  ceo: {
    fontSize: '0.7rem',
    color: 'gray',
    // backgroundColor: "#B9D9EB",
  // marginTop:"-10px",
  marginRight:"2px",
    textAlign:"left",
    // padding: "5px",
    // borderRadius: "5px",
  },
  infoContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap", // Ensures responsiveness
    gap: "20px", // Adds space between columns
  },
  leftColumn: {
    flex: 1, // Takes equal width
    minWidth: "200px", // Ensures responsiveness
  },
  rightColumn: {
    flex: 1,
    minWidth: "200px",
    textAlign: "right", // Aligns text to the right
  },
  info: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  infoIcon: {
    fontSize: "18px",
  },
  brief: {
   
    textAlign: "left",

  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '0.9rem',
    backgroundColor: '#2F3B57',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
};


export default ClientProfileCard;
